'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MsgService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _msgService = require('./msg.service.scss');

var _msgService2 = _interopRequireDefault(_msgService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MsgService = exports.MsgService = function () {
  function MsgService($mdToast) {
    _classCallCheck(this, MsgService);

    this.$mdToast = $mdToast;
  }

  _createClass(MsgService, [{
    key: 'displaySuccessMsg',
    value: function displaySuccessMsg(msg) {
      this.$mdToast.show({
        template: '<md-toast class="md-toast f-toast success" layout="row">\n                    <span flex>' + msg + '</span>\n                    <div class="md-action" ng-click="closeToast()">\n                      <i class="fa fa-times"></i>\n                    </div>\n                 </md-toast>',
        position: 'top center',
        hideDelay: 4000,
        controller: function controller($scope, $mdToast) {
          $scope.closeToast = function () {
            return $mdToast.hide();
          };
        }
      });
    }
  }, {
    key: 'displayWarningMsg',
    value: function displayWarningMsg(msg) {
      this.$mdToast.show({
        template: '<md-toast class="md-toast f-toast warning" layout="row">\n                  <span flex>' + msg + '</span>\n                    <div class="md-action" ng-click="closeToast()">\n                      <i class="fa fa-times"></i>\n                    </div>\n                 </md-toast>',
        position: 'top center',
        hideDelay: 8000,
        controller: function controller($scope, $mdToast) {
          $scope.closeToast = function () {
            return $mdToast.hide();
          };
        }
      });
    }
  }, {
    key: 'displayErrorMsg',
    value: function displayErrorMsg(msg) {
      if (msg) {
        var message = angular.isString(msg) ? msg : msg.data.errors[0].code + ' ' + msg.data.errors[0].title + ': ' + msg.data.errors[0].detail;
        this.$mdToast.show({
          template: '<md-toast class="md-toast f-toast error" layout="row">\n                    <span flex>' + message + '</spanflex>\n                    <div class="md-action" ng-click="closeToast()">\n                      <i class="fa fa-times"></i>\n                    </div>\n                  </md-toast>',
          position: 'top center',
          hideDelay: false,
          controller: function controller($scope, $mdToast) {
            $scope.closeToast = function () {
              return $mdToast.hide();
            };
          }
        });
      }
    }
  }]);

  return MsgService;
}();


//////////////////
// WEBPACK FOOTER
// ./common/services/messages/msg.service.js
// module id = 477
// module chunks = 0